module.exports = __webpack_public_path__ + "img/76008.9df39dcd.svg";